import Phaser from "phaser";
import { socket, socketConnected } from "../../../../utils/nakama";
import { matchIdGame, isSpectator } from "../../Game.jsx";
import opCodes from "../../../../constants/opCodes.jsx";
import { spectatorBoxCount } from "../BonezGame";

export default class EmojiMenu extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, emojiPack, spectatorsEmojis) { //emojiPack is of type map
        super(scene, x, y, 'all_images', 'emote_button');
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.depth = 100;
        this.emojiPack = emojiPack;
        this.spectatorsEmojis = spectatorsEmojis
        this.menuIsVisible = false;
        this.menuEmojis = [];
        this.availableEmojis = new Map();
        this.emojiOption1 = null;
        this.emojiOption2 = null;
        this.selectedPack = 'default_pack'; // selected by default
        this.emojiLoaded = false;
        this.emojiOptionCoordinates = null;

        // declare sounds first
        this.snd_click = this.scene.sound.add('snd_click');
        this.LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

        // fetching values from local storage or use default values
        this.soundVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
        this.soundVolume = this.soundVolumeFromStorage !== null ? +this.soundVolumeFromStorage / 100 : 12.5 / 100;

        this.checkForVolumeChange = () => {
            let newSoundVolume = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);
            newSoundVolume = newSoundVolume !== null ? +newSoundVolume / 100 : 12.5 / 100;

            if (this.soundVolume !== newSoundVolume) {
                this.soundVolume = newSoundVolume;

                this.snd_click.setVolume(this.soundVolume);
            }
        }

        this.scene.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        // set up coordinates for emoji option components
        this.setUpEmojiOptionCoordinates(this.scale);

        // click listener
        // this.setupGlobalClickListener();

        this.emojiMenuBackground = this.scene.add.image(this.emojiOptionCoordinates.menuBackground.x, this.emojiOptionCoordinates.menuBackground.y, 'all_images', 'emoji_panel_bg').setDepth(this.depth - 1).setScale(this.scale * 1.25);

        // emoji switch buttons
        this.emojiOptionContainer = this.scene.add.container(100, 100).setDepth(this.depth + 3);

        // emoji containers
        this.emoji1Container = this.scene.add.container(100, 100).setDepth(this.depth + 3);
        this.emoji2Container = this.scene.add.container(100, 100).setDepth(this.depth + 3);

        // emoji option components
        this.emojiOption1 = this.scene.add.image(this.emojiOptionCoordinates.options.x1, this.emojiOptionCoordinates.options.y, 'option1').setScale(0.32*this.scale).setDepth(this.depth + 2);
        this.emojiOption1.setInteractive();
        this.emojiOption2 = this.scene.add.image(this.emojiOptionCoordinates.options.x2, this.emojiOptionCoordinates.options.y, 'option2').setScale(0.32*this.scale).setDepth(this.depth + 2);
        this.emojiOption2.setInteractive();

        this.emojiOption1Background = this.scene.add.rectangle(this.emojiOptionCoordinates.backgrounds.x1, this.emojiOptionCoordinates.backgrounds.y, this.emojiOptionCoordinates.backgrounds.width, this.emojiOptionCoordinates.backgrounds.length, 0x1b3a5d).setDepth(this.depth + 1).setVisible(false);
        this.emojiOption2Background = this.scene.add.rectangle(this.emojiOptionCoordinates.backgrounds.x2, this.emojiOptionCoordinates.backgrounds.y, this.emojiOptionCoordinates.backgrounds.width, this.emojiOptionCoordinates.backgrounds.length, 0x1b3a5d).setDepth(this.depth + 1).setVisible(false);

        this.emojiOptionContainer.add(this.emojiOption1);
        this.emojiOptionContainer.add(this.emojiOption2);

        this.emojiOption1Background.setVisible(false);
        this.emojiOption2Background.setVisible(false);

        this.setMenuVisibility(false);
        this.menuIsVisible = false;
       
        this.scene.load.once('complete', () => {
            this.emojiOption1.on('pointerover', () => {
                this.emojiOption1Background.setVisible(true); // Change the background color on hover
            });
    
            this.emojiOption1.on('pointerout', () => {
                this.emojiOption1Background.setVisible(false); // Remove the background color on hover out
            });

            this.emojiOption1.on('pointerdown', () => {
                this.selectedPack = 'default_pack';
                this.toggleEmojiVisibility();
                console.log('Hello from emojiOption1');
            });

            this.emojiOption2.on('pointerover', () => {
                this.emojiOption2Background.setVisible(true); // Change the background color on hover
            });
    
            this.emojiOption2.on('pointerout', () => {
                this.emojiOption2Background.setVisible(false); // Remove the background color on hover out
            });
    
            this.emojiOption2.on('pointerdown', () => {
                this.selectedPack = 'neko-kun';
                this.toggleEmojiVisibility();
                console.log('Hello from emojiOption2');
            });
        });
        this.scene.load.start();

        this.on("pointerdown", () => {
            this.snd_click.play();
            this.snd_click.setVolume(this.soundVolume);

            if (!this.emojiLoaded) { // Prevent emoji (default pack) overload
                this.setMenuVisibility(true);

                this.emojiOption1Background.setVisible(false);
                this.emojiOption2Background.setVisible(false);

                this.loadMenuEmojis(this.emojiPack);
                this.emojiLoaded = true;
            } else {
                this.setMenuVisibility(!this.menuIsVisible);
                this.menuIsVisible = !this.menuIsVisible;

                if (this.menuIsVisible) {
                    this.emojiOption1Background.setVisible(false);
                    this.emojiOption2Background.setVisible(false);

                    this.toggleEmojiVisibility();
                } else {
                    this.menuEmojis.forEach(emoji => emoji.setVisible(false));
                }
            }
        });

        // this.setMenuVisibility(false);
        this.toggleEmojiVisibility();
    }

    loadMenuEmojis (emojiPack) {
        //delete previous menu emojis
        for (let i = 0; i < this.menuEmojis.length; i++) {
            this.menuEmojis[i].destroy();
        }

        const increment = this.emojiMenuBackground.width*this.emojiMenuBackground.scaleX/8 - 80*this.scale/8;
        const startingX = this.x - (this.emojiMenuBackground.width*this.emojiMenuBackground.scale) + increment/2 + 40*this.scale;
        const startingY = this.y - (this.emojiMenuBackground.height*this.emojiMenuBackground.scale/2 + 90*this.scale); 

        for (const packName in emojiPack) {
            if (emojiPack.hasOwnProperty(packName)) {
                const pack = emojiPack[packName];

                pack.emojis.forEach((emojiName, i) => {
                    this.scene.load.image(emojiName, `/bonez/emojis/${pack.name}/${emojiName}.png`);
                    this.scene.load.once('complete', () => {
                        const availableEmoji = this.scene.add.sprite(startingX + i*increment, startingY, emojiName).setOrigin(0.5, 0.5).setDepth(this.depth + 1).setScale(this.scale * 0.46).setVisible(false);

                        this.menuEmojis.push(availableEmoji);
                        this.availableEmojis.set(emojiName, true);
                        availableEmoji.on("pointerdown", async (pointer, x, y, event) => {
                            //send emoji data to server
                            if (socketConnected) {
                                const data = {
                                    packName: emojiPack[packName].name,
                                    emojiName: emojiName,
                                }
                                if (!isSpectator) {
                                    await socket.sendMatchState(matchIdGame, opCodes.playerSendEmojiData, JSON.stringify(data));
                                }
                                else {
                                    await socket.sendMatchState(matchIdGame, opCodes.spectatorSendEmojiData, JSON.stringify(data)); 
                                }
                            }
                            
                            
                            //event.stopPropagation();
                        });
                        availableEmoji.on("pointerover", (pointer, x, y, event) => {
                            availableEmoji.setScale(this.scale * 0.55);
                            //event.stopPropagation();
                        });
                        availableEmoji.on("pointerout", (pointer, event) => {
                            availableEmoji.setScale(this.scale * 0.46);
                            //event.stopPropagation();
                        });

                        if (packName === this.selectedPack) {
                            availableEmoji.setVisible(true);
                            availableEmoji.setInteractive();
                        } else {
                            availableEmoji.setVisible(false);
                            availableEmoji.disableInteractive();
                        }
                    });
                });
            }
        }
        this.scene.load.start();
    }

    toggleEmojiVisibility() {
        for (const packName in this.emojiPack) {
            if (this.emojiPack.hasOwnProperty(packName)) {
                const pack = this.emojiPack[packName];

                pack.emojis.forEach((emojiName => {
                    const emoji = this.menuEmojis.find((e) => e.texture.key === emojiName);
                    if (emoji) {
                        emoji.setVisible(packName === this.selectedPack);

                        if (packName === this.selectedPack) {
                            emoji.setInteractive();
                        } else {
                            emoji.disableInteractive();
                        }
                    }
                }))
            }
        }
    }

    setupGlobalClickListener() {
        this.scene.input.on('pointerdown', (pointer) => {
            if (!this.emojiMenuBackground.getBounds().contains(pointer.x, pointer.y)) {
                this.emojiOption1Background.setVisible(false);
                this.emojiOption2Background.setVisible(false);

                this.setMenuVisibility(false);
                this.menuIsVisible = false;
            }
        });
    }

    setUpEmojiOptionCoordinates(scale) {
        if (scale === 0.7) {
            // Desktop
            if (!this.spectatorsEmojis) {
                this.emojiOptionCoordinates = {
                    options: {
                        x1: 2185,
                        x2: 2340,
                        y: 1700
                    },
                    backgrounds: {
                        x1: 2285,
                        x2: 2440,
                        y: 1795,
                        width: 126,
                        length: 150
                    }, 
                    menuBackground: {
                        x: 2880,
                        y: 1701.36
                    },
                }
            } else {
                this.emojiOptionCoordinates = {
                    options: {
                        x1: 1585,
                        x2: 1740,
                        y: 1810
                    },
                    backgrounds: {
                        x1: 1685,
                        x2: 1840,
                        y: 1905,
                        width: 126,
                        length: 150
                    },
                    menuBackground: {
                        x: 2270,
                        y: 1818
                    },
                }
            }
        } else {
            // Mobile
            if (!this.spectatorsEmojis) {
                this.emojiOptionCoordinates = {
                    options: {
                        x1: 1345,
                        x2: 1445,
                        y: 880
                    },
                    backgrounds: {
                        x1: 1445,
                        x2: 1545,
                        y: 975,
                        width: 85,
                        length: 108
                    },
                    menuBackground: {
                        x: 1860,
                        y: 912
                    },
                }
            } else {
                this.emojiOptionCoordinates = {
                    options: {
                        x1: 875,
                        x2: 975,
                        y: 940
                    },
                    backgrounds: {
                        x1: 975,
                        x2: 1075,
                        y: 1034,
                        width: 85,
                        length: 108
                    },
                    menuBackground: {
                        x: 2270,
                        y: 1818
                    },
                }
            }
        }
    }

    drawEmojiArray(emojiDataArray, startX, startY, endY, xAllowance, yAllowance, emojiDataSpectatorArray, spectatorArray){
        emojiDataArray.forEach(emojiData => {
            if (this.availableEmojis.has(emojiData.emojiName)) { //type of emoji has been loaded before
                this.addEmojiAndTween(emojiData.emojiName, startX, startY, endY, xAllowance, yAllowance, emojiDataSpectatorArray, spectatorArray);
            }
            else { //type of emoji has NOT been loaded before
                this.scene.load.image(emojiData.emojiName, `/bonez/emojis/${emojiData.packName}/${emojiData.emojiName}.png`);
                this.scene.load.once('complete', () => {
                    this.availableEmojis.set(emojiData.emojiName, true);
                    this.addEmojiAndTween(emojiData.emojiName, startX, startY, endY, xAllowance, yAllowance, emojiDataSpectatorArray, spectatorArray);
                });
                this.scene.load.start();
            }
        });
    }

    displayReceivedEmoji(emojiDataArray, sender) { //data: [{packName: STRING, emojiName: STRING}, ...]
        if (!emojiDataArray) {
            console.log("emojiDataArray is null or undefined");
            return; // Exit the function early if any of the arrays is null or undefined
        }
        let startX;
        let startY;
        let endY;
        let xAllowance = this.scene.opponentBoard.width*this.scene.opponentBoard.scaleX*0.08;
        let yAllowance = this.scene.opponentBoard.height*this.scene.opponentBoard.scaleY*0.3;
        if (sender === "opponent") {
            startX = this.scene.opponentBoard.x + this.scene.opponentBoard.width/2*this.scene.opponentBoard.scaleX;
            startY = this.scene.opponentBoard.y + this.scene.opponentBoard.height/2*this.scene.opponentBoard.scaleY;
            endY = startY - this.scene.opponentBoard.height*this.scene.opponentBoard.scaleY;
        }
        else if (sender === "player") {
            startX = this.scene.playerBoard.x + this.scene.playerBoard.width/2*this.scene.playerBoard.scaleX;
            startY = this.scene.playerBoard.y + this.scene.playerBoard.height/2*this.scene.playerBoard.scaleY;
            endY = startY - this.scene.playerBoard.height*this.scene.playerBoard.scaleY;
        }

        this.drawEmojiArray(emojiDataArray, startX, startY, endY, xAllowance, yAllowance);
    }


    displayReceivedEmojiSpectator(emojiDataSpectatorArray, spectatorArray) { 
        if (!emojiDataSpectatorArray && !spectatorArray) {
            console.log("emojiDataSpectatorArray and spectatorArray is null or undefined");
            return; // Exit the function early if any of the arrays is null or undefined
        }
    
        let startX;
        let startY;
        let endY;
        let xAllowance = this.scene.opponentBoard.width * this.scene.opponentBoard.scaleX * 0.08;
        let yAllowance = this.scene.opponentBoard.height * this.scene.opponentBoard.scaleY * 0.3;
        let foundElement = -1;
        if (emojiDataSpectatorArray !== undefined) {
            for (let i = 0; i < emojiDataSpectatorArray.length; i++) {
                foundElement = spectatorArray.indexOf(spectatorArray.find(spectatorArray => spectatorArray.id === emojiDataSpectatorArray[i].spectatorId));
                if (foundElement !== undefined && foundElement !== null) {
                    startX = spectatorBoxCount.spectatorPfps[foundElement].x;
                    startY = spectatorBoxCount.spectatorPfps[foundElement].y + 50;
                    endY = startY - this.scene.playerBoard.height*this.scene.playerBoard.scaleY;
                    this.drawEmojiArray(Array(emojiDataSpectatorArray[i].data), startX, startY, endY, xAllowance, yAllowance, emojiDataSpectatorArray, spectatorArray);
                    break;
                }
            }
        }
    }
    
    
    
    


    addEmojiAndTween(emojiName, startXParam, startYParam, endYParam, xAllowance, yAllowance, emojiDataSpectatorArray, spectatorArray) {
        const duration = Math.random() * 3000 + 2000;
        const startX = startXParam + Math.random() * xAllowance * this.scale * (Math.random() - 0.5 < 0 ? -1 : 1);
        const startY = startYParam + Math.random() * yAllowance * this.scale * (Math.random() - 0.5 < 0 ? -1 : 1);
        const endY = endYParam + Math.random() * yAllowance * this.scale * (Math.random() - 0.5 < 0 ? -1 : 1);
        const amplitudeX = (Math.random() * 180 * this.scale + 76 * this.scale) * ((Math.random() - 0.5) < 0 ? -1 : 1);
        const frequencyX = Math.random() * 1 + 0.5;
        const phaseShiftX = Math.random() * 2 * Math.PI;
    
        const emojiGameObject = this.scene.add.sprite(0, 0, emojiName).setOrigin(0.5, 0.5).setScale(this.scale * 0.46);
        let pfpGameObject;
    
        if (emojiDataSpectatorArray && spectatorArray) {
            for (let i = 0; i < emojiDataSpectatorArray.length; i++) {
                let foundElement = spectatorArray.indexOf(spectatorArray.find(spectator => spectator.id === emojiDataSpectatorArray[i].spectatorId));
                if (foundElement !== -1) {
                    pfpGameObject = this.scene.add.sprite(emojiGameObject.width * 0.15, -(emojiGameObject.height * 0.15), spectatorBoxCount.spectatorPfps[foundElement].texture.key).setOrigin(0.5, 0.5).setScale(0.5);
                    break;
                }
            }
        }
    
        const container = this.scene.add.container(startX, startY);
        container.add(emojiGameObject);
        if (pfpGameObject) {
            container.add(pfpGameObject);
        }
    
        // Tween for the container
        this.scene.tweens.add({
            targets: container,
            y: { from: startY, to: endY },
            duration: duration,
            ease: 'Sine.easeOut',
            alpha: 0,
            onUpdate: (tween, target) => {
                const progress = tween.progress;
                const xOffset = amplitudeX * Math.sin(2 * Math.PI * frequencyX * progress + phaseShiftX);
                target.x = startX + xOffset;
    
                let prevX;
                let prevY;
                if (target.prevX) {
                    prevX = target.prevX;
                    prevY = target.prevY;
                    target.prevX = target.x;
                    target.prevY = target.y;
                } else {
                    prevX = startX;
                    prevY = startY;
                    target.prevX = target.x;
                    target.prevY = target.y;
                }
                const deltaX = target.x - prevX;
                const deltaY = target.y - prevY;
                if (Math.abs(deltaX) > 0.001) {
                    let angle = Phaser.Math.Angle.Between(0, 1, deltaX, deltaY);
                    target.rotation = Math.PI / 2 + angle;
                }
            },
            onComplete: () => {
                container.destroy();
            }
        });
    }
    

    setMenuVisibility(isVisible) {
        this.emojiMenuBackground.setVisible(isVisible);
        this.emojiOptionContainer.setVisible(isVisible);

        this.emojiOption1Background.setVisible(isVisible); 
        this.emojiOption2Background.setVisible(isVisible); 

        this.menuEmojis.forEach(emoji => {
            emoji.setVisible(isVisible);
        });
    }

    setButtonVisibility(isVisible) {
        this.setVisible(isVisible);
        if (!isVisible) {
            this.setMenuVisibility(false);
            this.menuIsVisible = isVisible;
        }
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("emojiMenu", function (x, y, scale, emojiMenu, spectatorsEmojis) {
    const emojiMenuInst = new EmojiMenu(this.scene, x, y, scale, emojiMenu, spectatorsEmojis);

    this.displayList.add(emojiMenuInst);
    this.updateList.add(emojiMenuInst);

    return emojiMenuInst;
})